import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconEllipse = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 2,
	height: 2,
	viewBox: "0 0 2 2",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		id: "Ellipse 55",
		cx: 1,
		cy: 1,
		r: 1,
		fill: "#D9D9D9"
	})
});
export default SvgIconEllipse;
